//クルー側のエンドポイント
const apiBasePath = process.env.APP_API_PATH;
const apiBasePathCrew = `${apiBasePath}/crew`;

export const CREW_END_POINTS = {
  SHARED: {},
  USER: {
    VAL: `${apiBasePath}/val`, //ユーザー情報
    INFO: `${apiBasePathCrew}/userinfo`, //ユーザー情報詳細
    PROFILE: `${apiBasePathCrew}/profile`, //プロフィール情報
    SKILL: `${apiBasePathCrew}/skill` //スキル情報
  },
  TASK: {
    TASK: `${apiBasePathCrew}/task`, //仕事詳細
    SUB_REPORT: `${apiBasePathCrew}/tasksubrpt`, //報告画面内の作業箇所用
    TASK_LIST_BY_VENUE: `${apiBasePathCrew}/taskrequest/v2/list-by-venue`, //物件ごとの仕事一覧
    TASK_LIST: `${apiBasePathCrew}/v3/task`, //仕事一覧
    SUGGEST: `${apiBasePathCrew}/v2/get-taskreq-mini`, //提案一覧
    SUGGEST_CREATE: `${apiBasePathCrew}/taskreq-mini`, //提案作成（親タスク＝自由）
    SUGGEST_CREATE_V2: `${apiBasePathCrew}/v2/taskreq-mini` //提案作成
  },
  REPORT: {
    TASK_REQCREW: {
      PLACE_ADD: `${apiBasePathCrew}/taskrpt` //箇所追加 /{taskrpt_id}でname編集も可
    },
    DETAIL: `${apiBasePathCrew}/taskrptcol`, //依頼内容の詳細
    VENUE: `${apiBasePathCrew}/venue`, //物件情報取得 venueの後に/{venueId}
    RESUBMIT: `${apiBasePathCrew}/taskrptcol/complete`, //${taskId}/resubmit 報告取り下げ
    CHECK: `${apiBasePathCrew}/taskrptcol/val`, //報告データが存在するかチェック
    REPORT_ONLY_DELETE: `${apiBasePathCrew}/task/crew-delete`, //${taskId} 報告のみ削除
    STATUS: {
      SAVE: `${apiBasePathCrew}/taskrpt`, //${id} 各ステータスの保存
      FINAL: `${apiBasePathCrew}/taskrptfinal` //${id}/status その他異常箇所の報告ステータス更新
    },
    ROTATE_PHOTOS: `${apiBasePathCrew}/rotate-photos`, //報告写真回転
    FEEDBACK_READ: `${apiBasePathCrew}/taskrptcol/crew-confirm`, //${taskId} フィードバック情報取得
    ABNORMAL_CATEGORY: `${apiBasePathCrew}/abnormal-category`, //異常箇所カテゴリー取得
    AI_PROOFREAD: `${apiBasePathCrew}/ai-proofread`, // AI校正の実行
    AI_PROOFREADING_SETTING: `${apiBasePathCrew}/ai-proofreading-setting`, // AI校正設定
    BULK_UPDATE_TASKSUBRPT_COMMENTS: `${apiBasePathCrew}/tasksubrpt/comments/bulk-update` //コメント一括更新
  },
  DASH_BOARD: {
    DASHBOARD: `${apiBasePathCrew}/dashboard`, //ダッシュボード
    INVOICE_REG_STATUS: `${apiBasePathCrew}/invoice_reg` //インボイス登録情報取得
  },
  MAP: {
    MAP_URL: `${apiBasePathCrew}/cosoji-map`, //募集マップのURL取得
    TASK_LIST: `${apiBasePathCrew}/tr/map` //募集マップの仕事一覧
  },
  VENUE: {
    DETAIL: `${apiBasePathCrew}/venue`, //物件詳細
    SEARCH: `${apiBasePathCrew}/venue-search` //物件検索
  },
  MY_PAGE: {
    DL_USAGE: `${apiBasePathCrew}/statement/download`, //作業明細ダウンロード
    DL_USAGE_AVAILABLE: `${apiBasePathCrew}/statement/available`, //作業明細ダウンロード可能年月取得
    TOOL_USAGE: {
      OWNER_SEARCH: `${apiBasePathCrew}/owner-search`, // 依頼者検索（既存取引先とCOSOJI依頼者の区別なし、qパラメータがない場合はレスポンスが全結果）
      OWNER_LIST: `${apiBasePathCrew}/owner-list`, // 依頼者リスト取得
      CHAT_CREATE: `${apiBasePathCrew}/chat/manual`, //手動チャット作成
      TASK_CREATE: `${apiBasePathCrew}/task/crew-create` //仕事（報告）作成
    }, //ツール利用
    RECOMMEND: `${apiBasePathCrew}/recommend` //おすすめ案件通知の設定取得
  },
  LOG: {
    MANUAL_ACCESS: `${apiBasePathCrew}/manual-access-log` //メール通知リンクの閲覧数カウント
  },
  FEATURE_FLAG: `${apiBasePathCrew}/feature-flags`
};
